import styled from "@emotion/styled";
import React from "react";
import cursorHover from "../../images/cursor-hover.png";
import Instagram from "./insta.png";

const Header = () => {
  return (
    <Sticky>
      <HeaderComponent>
        <a
          href="https://www.instagram.com/ryan_paxton/"
          target="_blank"
          rel="noreferrer"
          style={{ cursor: `url(${cursorHover}), auto` }}
        >
          <Icon src={Instagram} />
        </a>
      </HeaderComponent>
    </Sticky>
  );
};

const Sticky = styled.div({
  width: "100%",
  position: "fixed",
  top: 0,

  display: "flex",
  justifyContent: "flex-end",
  cursor: `url(${cursorHover}), auto`,
});

const Icon = styled.img({
  height: "30px",
  cursor: `url(${cursorHover}), auto`,
});

const HeaderComponent = styled.div({
  cursor: `url(${cursorHover}), auto`,
  padding: "16px",
  borderRadius: "0 0 0 8px",
  display: "flex",
  alignItems: "center",
  gap: "12px",

  backgroundColor: "#36F106",

  fontSize: "16px",
  fontFamily: "Pirulen",
  fontWeight: 600,
});

export default Header;
